<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'TwSnackbar',
  data() {
    return {
      showSnackbar: false,
      snackbarClasses: {
        success: 'green--text',
        error: 'red--text',
        warning: 'yellow--text',
        info: 'primary--text',
      },
      snackbarIcons: {
        success: 'check_circle',
        error: 'error',
        warning: 'warning',
        info: 'info',
      },
    };
  },
  computed: {
    ...mapState({
      show: state => state.snackbar.element.show,
      identifier: state => state.snackbar.element.identifier,
      message: state => state.snackbar.element.message,
      timeout: state => state.snackbar.element.timeout,
      button: state => state.snackbar.element.button,
    }),
  },
  methods: {
    ...mapActions({
      hide: 'snackbar/hide',
    }),
  },
  watch: {
    show(value) {
      this.showSnackbar = value;
    },
    showSnackbar(value) {
      if (!value) this.hide();
    },
  },
};
</script>

<template>
  <v-snackbar
    v-model="showSnackbar"
    bottom
    :timeout="timeout">
    <v-icon
      class="mr-3"
      :class="snackbarClasses[identifier]">
      {{ snackbarIcons[identifier] }}
    </v-icon>
    <v-flex>
      {{ $t(`snackbar.message.${message}`) }}
    </v-flex>
    <v-btn
      color="white"
      flat
      @click="showSnackbar = false">
      {{ $t(`snackbar.button.${button}`) }}
    </v-btn>
  </v-snackbar>
</template>



// WEBPACK FOOTER //
// src/components/TwSnackbar.vue